import { reportingYear } from "../constants";
import { addSectorTotals, summarize } from "./data";

const getCountries = (areas, gniGroup) =>
  Object.keys(areas)
    .map(areaId => ({
      id: parseInt(areaId, 0),
      ...areas[areaId]
    }))
    .filter(
      area => area.classification === "Country" && area.gniGroup === gniGroup
    );

const getMethods = (methods, methodId) =>
  methodId && methodId >= 0
    ? new Set([methodId])
    : new Set(
        Object.keys(methods)
          .map(methodId => parseInt(methodId, 10))
          .filter(methodId => methodId !== 1)
      );

export const calculateCountryExplorerCurrentChartData = (
  databases,
  indicatorId,
  gniGroup,
  methodId,
  sectorId
) => {
  const database = databases.core;

  const countries = getCountries(database.areas, gniGroup);
  const countryIds = new Set(countries.map(country => country.id));

  const methodIds = getMethods(database.methods, methodId);

  const sectorIds = sectorId >= 0 ? new Set([sectorId]) : new Set([6, 5, 4]);

  const data = addSectorTotals(database.data)
    .filter(
      datum =>
        datum.indicator === indicatorId &&
        countryIds.has(datum.area) &&
        methodIds.has(datum.method) &&
        sectorIds.has(datum.sector) &&
        datum.year === reportingYear
    )
    .map(datum => ({
      ...datum,
      country: database.areas[datum.area].area
    }));

  return summarize(data, [
    "area",
    ...(methodId === -2 ? ["method"] : []),
    ...(sectorId === -2 ? ["sector"] : [])
  ]).map(datum => ({
    ...datum,
    country: database.areas[datum.area].area,
    method: datum.method ? database.methods[datum.method] : undefined,
    sector: datum.sector ? database.sectors[datum.sector] : undefined
  }));
};

export const calculateCountryExplorerProjectionChartData = (
  databases,
  indicatorId,
  gniGroup,
  methodId
) => {
  const database = databases.core;

  const countries = getCountries(database.areas, gniGroup);
  const countryIds = new Set(countries.map(country => country.id));

  const methodIds = getMethods(database.methods, methodId);

  const data = database.data
    .filter(
      datum =>
        datum.indicator === indicatorId &&
        countryIds.has(datum.area) &&
        methodIds.has(datum.method)
    )
    .map(datum => ({
      ...datum,
      country: database.areas[datum.area].area
    }));

  return summarize(data, ["country", "year"]);
};

export const extractCountries = data =>
  Array.from(new Set(data.map(datum => datum.country)))
    .sort()
    .reduce((result, country, index) => {
      result[country] = index;

      return result;
    }, {});
